import { AttachmentFormModalAccess } from './AttachmentFormModal';
import { OpenButtonAccess } from './AttachmentFormModal.components';

export const AttachmentFormModal = AttachmentFormModalAccess;
export const AttachmentFormModalComponents = { OpenButton: OpenButtonAccess };
